<template>
  <div class="goods-info">
    <div>
      <el-form
        v-if="orderEditType!==2"
        ref="goodsInfoFilter"
        :model="form"
        label-width="90px"
        @submit.native.prevent
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              label="SKU编码"
              prop="itemNo"
            >
              <el-input v-model="form.itemNo" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="中文品名"
              prop="chineseCommodity"
            >
              <el-input v-model="form.chineseCommodity" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="英文品名"
              prop="englishCommodity"
            >
              <el-input v-model="form.englishCommodity" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-button
                type="primary"
                @click="()=>handleQuery(1)"
              >搜索</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <div class="trigger">
        <el-form>
          <el-button
            type="primary"
            @click="handleAdd"
          >新增</el-button>
          <el-button
            type="primary"
            @click="handleEdit"
          >编辑</el-button>
          <el-button
            type="primary"
            @click="handleDel"
          >删除</el-button>
        </el-form>
      </div>
    </div>
    <div style="display: flex;margin-top: 5px">
      <cargo-ag-grid
        ref="goodsTable"
        config-module="700002"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        style="height: 400px"
        :row-data="rowData"
      />
    </div>
    <div>
      <el-form>
        <cargo-pagination
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
          @pagination="()=>handleQuery()"
        />
      </el-form>
    </div>
    <goods-form
      ref="goodsForm"
      :visible="visible"
      :item="editRow"
      :edit-sku-no="editSkuNo"
      @onSave="goodsSave"
      @onClose="handleClose"
    />
  </div>
</template>
<script>
import goodsForm from './goodsForm'
import { getLoading } from '@/utils/utilBaseElement'
import {
  queryPoInfoItemPageable,
  savePoInfoIten,
  deletePoInfoItem,
  checkSavePoInfoItem
} from '@/api/OMS/order'
export default {
  name: 'GoodsInfo',
  components: { goodsForm },
  props: {
    orderEditType: {
      type: Number,
      default: () => 2
    },
    orderUuid: { type: String, default: () => '' },
    poState: { type: Number, default: () => null }
  },
  data() {
    return {
      visible: false,
      editSkuNo: false, // 是否可以编辑skuNo
      form: {
        itemNo: '',
        chineseCommodity: '',
        englishCommodity: ''
      },
      gridOptions: {
        suppressCellSelection: true,
        columnApi: null,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'SKU编码',
          colId: 'itemNo',
          field: 'itemNo',
          width: 150
        },
        {
          headerName: '中文品名',
          colId: 'chineseCommodity',
          field: 'chineseCommodity',
          width: 150
        },
        {
          headerName: '英文品名',
          colId: 'englishCommodity',
          field: 'englishCommodity',
          width: 150
        },
        {
          headerName: 'MFG号',
          colId: 'mfg',
          field: 'mfg',
          width: 150
        },
        {
          headerName: '件数',
          colId: 'quantity',
          field: 'quantity',
          width: 150,
          cellRenderer: (item) => {
            const { data } = item
            if (data.quantity !== data.packageItemQuantity) {
              return `<span style="color:red">${data.quantity}</span>`
            } else {
              return `<span>${data.quantity}</span>`
            }
          }
        },
        {
          headerName: 'HS Code',
          colId: 'hsCode',
          field: 'hsCode',
          width: 150
        },
        {
          headerName: '创建人',
          colId: 'createUserName',
          field: 'createUserName',
          width: 150
        },
        {
          headerName: '接收时间',
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 150
        },
        {
          headerName: '更新人',
          colId: 'modifyUserName',
          field: 'modifyUserName',
          width: 150
        },
        {
          headerName: '更新时间',
          colId: 'dateModified',
          field: 'dateModified',
          width: 150
        }
      ],
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      editRow: null
    }
  },
  watch: {
    orderUuid(newVal, oldVal) {
      if (!newVal) {
        this.rowData = []
      }
      if (newVal && newVal !== oldVal) {
        this.fetchList()
      }
    }
  },
  methods: {
    fetchList() {
      this.loading = getLoading()
      const params = {
        poInfoUuid: this.orderUuid,
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      Object.keys(this.form).forEach((key) => {
        if (this.form[key]) {
          params[key] = this.form[key]
        }
      })
      queryPoInfoItemPageable(params)
        .then((res) => {
          this.rowData = res.data.list
          this.filter.total = Number(res.data.total)
          this.loading.close()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    handleQuery(type = 0) {
      if (type !== 0) {
        this.filter.pageNum = 1
      }
      this.fetchList()
    },
    handleReset() {
      this.$refs['goodsInfoFilter'].resetFields()
      this.filter.pageNum = 1
      this.fetchList()
    },
    handleClose() {
      this.visible = false
      this.editRow = null
      this.$refs.goodsForm.$refs.form.resetFields()
    },
    goodsSave(item) {
      const params = {
        poInfoUuid: this.orderUuid,
        ...item
      }
      savePoInfoIten(params)
        .then((res) => {
          this.$message.success('保存成功')
          this.$refs.goodsForm.loading.close()
          this.handleQuery(1)
          this.handleClose()
          this.$emit('goodsSave')
        })
        .catch(() => {
          this.$refs.goodsForm.loading.close()
        })
    },
    handleAdd() {
      this.editSkuNo = true
      if (this.orderEditType === 2) {
        this.$message.error('请先保存订单')
        return
      }
      this.visible = true
    },
    handleEdit() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择一条数据')
        return
      }
      this.editRow = selectedRows[0]
      checkSavePoInfoItem({ poItemUuid: this.editRow.poItemUuid }).then((res) => {
        this.editSkuNo = !res.data // 是否可以编辑skuNo,默认不可以，只有未关联包装的时候可以
        this.visible = true
      })
    },
    handleDel() {
      const { api } = this.gridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.error('请选择一条数据')
        return
      }
      const item = selectedRows[0]
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, item.itemNo),
          h('span', { style: 'margin: 0 10px' }, item.chineseCommodity),
          h('span', null, item.englishCommodity)
        ]),
        h('p', { style: 'color: red' }, '是否确定删除此商品？')
      ])
      this.$confirm(content, '删除商品', {
        type: 'warning'
      }).then(() => {
        deletePoInfoItem({ poInfoItemUuid: item.uuid })
          .then((res) => {
            this.$message.success('删除成功')
            this.handleQuery(1)
          })
          .catch(() => {
            this.loading.close()
          })
      })
    }
  }
}
</script>
